<template>
  <base-content-block
    class="area-chart"
    title="Rank Zone Time Progression"
  >
    <div
      id="area-chart"
      class="area-chart__wrapper"
    >
      <base-select
        v-if="!isScreenshotTaking"
        v-model="webPropertyGroupId"
        class="area-chart__web-property-select"
        :options="webPropertyGroups"
        :show-top-border="true"
        placeholder="Web Property"
      >
        <template #type="{option}">
          <span
            v-if="option.type === 'Clients'"
            class="area-chart__client"></span>
          <span
            v-else-if="option.type === 'Siblings'"
            class="area-chart__sibling"></span>
          <span
            v-else-if="option.type === 'Competitors'"
            class="area-chart__competitor"></span>
        </template>
      </base-select>
      <!-- <button
        v-if="!isScreenshotTaking"
        class="area-chart__annotation-button"
        :class="{ 'area-chart__annotation-button_enabled': isAnnotationEnabled }"
        @click.prevent="toogleAnnotation"
      >
        annotations
      </button> -->
      <div class="area-chart__toggles">
        <base-check-box
          v-if="!isScreenshotTaking"
          v-model="isAnnotationEnabled"
          :toggle-view="true"
          class="area-chart__annotation-toggle"
          label="Annotations"
        />
        <base-check-box
          v-model="showVerticalGridlines"
          :toggle-view="true"
          :disabled="false"
          class="area-chart__toggle-y-axis"
          label="Y-Axis Lines"
        />
      </div>
      <base-area-chart-date-picker
        v-show="!isScreenshotTaking"
        ref="datepicker"
        class="area-chart__date-picker"
        use-fields
        :columns="3"
        :restrictions="dateRange"
        :dates="dates"
        @apply="onDateRangeChanged"
      />
      <template>
        <div
          v-if="notEnoughData"
          class="rank-zone__no-data"
        >
          Not enough data for drawing a chart
        </div>
        <div
          v-else
          class="area-chart__chart-wrapper"
        >
          <div
            v-if="screenshotTitle"
            class="area-chart__chart-subtitle"
          >
            Rank Zone Time Progression -
            <span class="area-chart__chart-subtitle_highlighted">{{ screenshotTitle }}</span>
          </div>
          <BaseAreaChart
            ref="areaChart"
            :chart-data="chartData"
            class="area-chart__chart"
            :show-vertical-gridlines="showVerticalGridlines"
          />
        </div>
      </template>
      <div
        v-if="isAnnotationMarkersShown"
        ref="annotations"
        class="area-chart__annotation-icons"
        :style="annotationWrapperStyles"
      >
        <base-material-design-icon
          v-for="(annotation, index) in annotations"
          :key="annotation.id"
          v-rfx-tooltip="customTooltipOptions[index]"
          :icon-style="{ 'margin-left': '-7px' }"
          :style="annotationStyles[index]"
          :class="[
            'area-chart__annotation-icons_icon',
            `area-chart__annotation-icons_icon_${annotation.prevType}`
          ]"
          icon="comment"
          @click="selectAnnotationDate(annotation.date)"
        />
      </div>
      <div class="area-chart__checkboxes">
        <base-check-box
          v-for="(item, index) in columns"
          :key="item"
          v-model="filters.columns[item]"
          class="area-chart__checkbox"
          :checkbox-color="checkboxColor[index]"
          :label="item"
        >
          <!--          <span class="area-chart__color" :style="getItemColor(index)"/>-->
        </base-check-box>
      </div>
      <base-annotations-manager
        v-if="isAnnotationEnabled && !isScreenshotTaking"
        v-model="annotationTypes"
        disable-u-r-l
        :min-date="minDate"
        :annotations="managerAnnotations"
        @sortAnnotations="sortAnnotations"
        @updateData="$emit('updateData')"
        @close="toogleAnnotation"
      />
    </div>
    <template #title-additional>
      <base-screenshot
        :id="'area-chart'"
        :name="screenshotName"
        class="area-chart__screenshot"
        @screenshot="onScreenShotStatusChanged"
      />
    </template>
  </base-content-block>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import Progress from '../rank-zone/progress/Progress'
import BaseAreaChart from '../../../common/BaseAreaChart'
import BaseAreaChartDatePicker from '../../../common/BaseAreaChartDatePicker'

const emptyFilters = {
  columns: {},
  startDate: null,
  endDate: null
}
const allColors = [
  '#26a303', '#0be129', '#37f7ae', '#49b6e6',
  '#284aff', '#9013fe', '#ff4f4f', '#3a3a3a'
]
const MILISEC_ONE_DAY = 86400000
/**
 * Component is adapter for BaseAreaChart. Used in {@link Progress} tab
 */
export default {
  name: 'AreaChart',
  props: {
    snapshots: {
      type: Array,
      required: true
    },
    cells: {
      type: Array,
      required: true
    },
    selectedType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      filters: { ...emptyFilters },
      chartData: {},
      webPropertyGroupId: null,
      annotationTypes: ['client'],
      annotationSelectedDate: '',
      pxPerDate: 0,
      checkboxColor: [...allColors],
      isDatePickerOpened: false,
      annotationsWrapperWidth: 0,
      isAnnotationEnabled: false,
      annotationWrapperStyles: {},
      isScreenshotTaking: false,
      showVerticalGridlines: true,
      throttle: _.throttle(
        () => {
          if (this.$refs.areaChart && this.$refs.annotations) {
            const chartElement = this.$refs.areaChart.$el.querySelector('rect')
            if (!chartElement) {
              this.$nextTick(() => {
                this.throttle()
              })
              return
            }
            const blockWidth = +chartElement.getAttribute('width')
            this.annotationsWrapperWidth = blockWidth
            const left = chartElement.getAttribute('x')
            this.annotationWrapperStyles = {
              width: blockWidth + 'px',
              left: left + 'px'
            }
            this.pxPerDate = blockWidth / (Math.round(Math.abs((this.chartData.ticks[0].v - this.chartData.ticks[this.chartData.ticks.length - 1].v) / MILISEC_ONE_DAY)))
          }
        },
        100,
        { leading: true, trailing: true }
      )
    }
  },
  watch: {
    cells: {
      handler (value) {
        /* force Vue reactivity system work properly */
        value.forEach(item => this.$set(this.filters.columns, item.label, !item.disabledByDefault))
      },
      immediate: true
    },
    isAnnotationMarkersShown (v) {
      v && this.$nextTick(this.countPixelsPerDate)
    },
    selectedType: {
      handler () {
        this.prepareChartData()
      },
      immediate: true
    },
    webPropertyGroups: {
      handler (groups) {
        if (groups.length) {
          /* set default webPropertyGroup */
          this.webPropertyGroupId = groups[0].value
        }
        this.sendWebPropertyGroup()
      },
      immediate: true
    },
    snapshots: {
      handler (value) {
        this.prepareChartData()
      },
      immediate: true
    },
    filters: {
      handler (value) {
        this.prepareChartData()
      },
      deep: true,
      immediate: true
    },
    webPropertyGroupId: 'sendWebPropertyGroup'
  },
  mounted () {
    this.countPixelsPerDate()
    window.addEventListener('resize', this.countPixelsPerDate)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.countPixelsPerDate)
  },
  computed: {
    ...mapState('rankZoneCommon', {
      /* prepare webPropertyGroup for dropdown */
      webPropertyGroups (state) {
        return state.webPropertyGroups.map(item => {
          return { value: item._id, label: item.label, type: item.type,
            attributes: item.type === 'Clients' ? [{ 'private-content': true }] : [],
          }
        }) || []
      }
    }),
    ...mapState('rankZoneProgress', {
      annotations (state) {
        return state.annotations.filter(i => {
          const startDate = this.filters.startDate || moment(this.minDate).subtract(1, 'days')
          const endDate = this.filters.endDate || moment(this.chartData.ticks[this.chartData.ticks.length - 1].v).add(1, 'days')
          const dateFilter = (!startDate || !endDate) || moment(i.prevDate).isBetween(startDate, endDate)

          const typeFilter = !this.annotationTypes.length || this.annotationTypes.includes(i.prevType)

          return dateFilter && typeFilter
        })
      },
      managerAnnotations (state) {
        return state.annotations.filter(i => {
          const startDate = this.filters.startDate
          const endDate = this.filters.endDate
          const dateFilter = !this.annotationSelectedDate
            ? (!startDate || !endDate) || moment(i.prevDate).isBetween(startDate, endDate)
            : this.annotationSelectedDate === i.prevDate

          const typeFilter = !this.annotationTypes.length || this.annotationTypes.includes(i.prevType)

          return dateFilter && typeFilter
        })
      }
    }),
    minDate () {
      return this.chartData.ticks[0].v
    },
    columns () {
      return this.cells.map(item => item.label)
    },
    notEnoughData () {
      const isSomeColumnChecked = Object.values(this.filters.columns).some(item => item)
      const isSomeSnapshotsChecked = _.get(this.chartData, 'data', []).length > 1
      return !isSomeColumnChecked || !isSomeSnapshotsChecked
    },
    /**
     * This prop created as array of styles to handle pxPerDate changes and recalculate style
     */
    annotationStyles () {
      return this.annotations.map(i => {
        const left = this.pxPerDate * (Math.round(Math.abs((this.chartData.ticks[0].v - new Date(i.prevDate)) / MILISEC_ONE_DAY)))
        return {
          left: left + 'px',
          top: left <= 20 || left >= this.annotationsWrapperWidth - 30 ? '13px' : '0',
          'font-size': this.annotationSelectedDate === i.date ? '20px' : '14px'
        }
      })
    },
    customTooltipOptions () {
      return this.annotations.map(i => this.getTooltipOptions(i))
    },
    isAnnotationMarkersShown () {
      return this.isAnnotationEnabled && !this.notEnoughData && !this.isScreenshotTaking
    },
    screenshotTitle () {
      return this.isScreenshotTaking ? _.get(this.getWebPropertyGroup(), 'label', '') : ''
    },
    /**
     * this property restricts date interval in picker
     * */
    dateRange () {
      const snapshots = this.snapshots ? this.snapshots.map(item => moment(item.label).toDate()) : []
      const first = snapshots.length > 0 ? moment(snapshots[0]).add(-1, 'd').toDate() : null
      const last = snapshots.length > 0 ? moment(snapshots[snapshots.length - 1]).add(1, 'd').toDate() : null
      return [first, last]
    },
    dates () {
      return this.snapshots.map(item => moment(item.label).toDate()) || []
    },
    screenshotName(){
      return `${this.selectedClient.name}_Rank Zone_Progress_${moment(Date.now()).format('YYYY-MM-DD')}`
    }
  },
  methods: {
    ...mapActions('rankZoneProgress', ['sortAnnotations']),
    /**
     * Preparing chart data for {@link BaseAreaChart} according to
     * {@link https://developers.google.com/chart/interactive/docs/datatables_dataviews#arraytodatatable}
     * @returns  chartData object with nex properties:
     *   data: array of chart data,
     *   colorSchema: array of colors,
     *   ticks: array of additional x-axis values see hAxis.ticks in chart options {@link https://developers.google.com/chart/interactive/docs/gallery/areachart#configuration-options }
     *
     */
    prepareChartData () {
      const checkedColumns = this.cells.filter(item => this.filters.columns[item.label])
      const header = [ 'Snapshot', ...checkedColumns.reduce((arr, cell) => {
        arr.push(cell.label)
        arr.push({ type: 'string', role: 'tooltip', p: { html: true } })
        return arr
      }, []) ]
      const data = [header]
      let ticks = []
      let filteredSnapshots = this.snapshots
      if (this.filters.startDate || this.filters.endDate) {
        filteredSnapshots = this.snapshots.filter(item => moment(item.label).isBetween(this.filters.startDate, this.filters.endDate))
      }

      const createCustomTooltip = (date, zone, msv, kw) => {
        return `
          <div style="padding: 0 16px">
            <p><b>${date}</b></p>
            <p>Zone: ${zone}</p>
            <p>MSV: ${msv}</p>
            <p>KWs: ${kw}</p>
          </div>
        `
      }

      filteredSnapshots.forEach(
        (item, index, array) => {
          const entry = []
          entry.push(moment(item.label).toDate())
          const dateLabel = (index === 0 || index === array.length - 1) ? moment(item.label).format('YYYY-M-D') : ''
          ticks.unshift({ v: moment(item.label).toDate(), f: dateLabel })
          const selectedType = this.selectedType
          checkedColumns.forEach(cell => {
            let data = item[cell.propName]
            if (selectedType && Object.keys(item[selectedType]).length) {
              data = item[selectedType][cell.propName]
            }
            entry.push(data)
            entry.push(createCustomTooltip(item.label, cell.label, item.msv[cell.propName], item.keyword[cell.propName]))
          })
          data.push(entry)
        }
      )
      const colorSchema = this.columns.reduce((acc, name, index) => {
        if (this.filters.columns[name]) {
          acc.push(allColors[index])
        }
        return acc
      }, [])
      this.chartData = {
        data,
        ticks,
        colorSchema
      }
    },
    getItemColor (index) {
      return { 'background-color': allColors[ index ] }
    },
    reset () {
      this.filters = { ...emptyFilters }
    },
    toogleAnnotation () {
      this.isAnnotationEnabled = !this.isAnnotationEnabled
    },
    selectAnnotationDate (date) {
      this.annotationSelectedDate = this.annotationSelectedDate === date ? '' : date
    },
    getTooltipOptions (annotation) {
      const html = `
        <div style="padding: 14px; border-radius: 12px; border: 2px solid #e7e9eb; background-color: #ffffff">
          <div style="display: flex; align-items: center">
            <div style="margin-right: 43px; padding-bottom: 4px;">
              <span style="width: max-content; display: block; font-size: 14px; font-weight: 800;">${annotation.name}</span>
              <span style="display: block; font-size: 12px;">${moment(annotation.date).format('MMM DD, YYYY')}</span>
            </div>
            <span style="margin-right: 11px; margin-top: -6px;">${annotation.type === 'system' ? 'System' : annotation.type === 'client' ? 'Project' : 'URL'}</span>
            <span style="color: #${annotation.type === 'system' ? 'ff4f4f' : annotation.type === 'client' ? 'ff862c' : '284aff'};">
              <svg fill="currentColor" width="14" height="14" viewBox="0 0 24 24" class="material-design-icon__svg">
                <path d="M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M5,5V7H19V5H5M5,9V11H13V9H5M5,13V15H15V13H5Z"></path>
              </svg>
            </span>
          </div>
          <div style="margin-top: 13px;">${annotation.note}</div>
        </div>
      `
      return {
        html
      }
    },
    countPixelsPerDate () {
      if (this.isAnnotationMarkersShown) {
        this.throttle.flush()
        this.throttle()
      }
    },
    sendWebPropertyGroup () {
      this.$emit('web-property', this.getWebPropertyGroup())
    },
    getWebPropertyGroup () {
      return this.webPropertyGroupId
        ? this.webPropertyGroups.find(item => item.value === this.webPropertyGroupId)
        : null
    },
    /**
     * callback invoked when changed date range on date {@link BaseAreaChartDatePicker}
     * @param range - selected date range
     */
    onDateRangeChanged (range) {
      this.filters.startDate = range.date_from
      this.filters.endDate = range.date_to
      this.prepareChartData()
      this.$nextTick(this.countPixelsPerDate)
    },
    onScreenShotStatusChanged(status){
      this.isScreenshotTaking = status
    }
  }
}
</script>

<style scoped lang="scss">

  .area-chart {
    flex: 1 1 100%;
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 10px;
    position: relative;

    // &__toggle-y-axis {
    //   position: absolute;
    //   top: 25px;
    //   right: 100px;
    // }

    // &__annotation-button {
    //   border: solid 1px rgba(1, 22, 39, 0.1);
    //   background-color: transparent;
    //   border-radius: 4px;
    //   width: 105px;
    //   height: 40px;
    //   text-align: center;
    //   text-transform: uppercase;
    //   color: $rfx-dark-march;
    //   font-size: 10px;
    //   font-weight: 900;
    //   position: absolute;
    //   top: 15px;
    //   right: 550px;

    //   &_enabled {
    //     color: white;
    //     background-color: $rfx-cyan;
    //     border-color: $rfx-cyan !important;
    //   }
    // }

    // &__annotation-toggle {
    //   position: absolute;
    //   top: 25px;
    //   right: 240px;
    // }

    &__toggles {
      position: absolute;
      top: 15px;
      right: 80px;
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 10px 16px;
      border-left: 1px solid $rfx-medium-grey;
      border-right: 1px solid $rfx-medium-grey;
    }

    &__annotation-icons {
      position: relative;
      height: 16px;
      margin-top: -44px;
      margin-bottom: 28px;

      &_icon {
        width: 0px;
        cursor: pointer;
        position: absolute;

        &_system {
          color: $rfx-light-red;
        }

        &_client {
          color: $rfx-orange;
        }

        &_url {
          color: $rfx-cyan;
        }
      }
    }

    &__screenshot {
      font-size: 18px;
      margin-top: -6px;
      cursor: pointer;

      &:hover {
        color: $rfx-bright-turquoise;
      }
    }
    &__wrapper{
      width: 100%;
      padding-top: 20px;
      box-sizing: border-box;
    }

    &__chart-subtitle {
      margin: 20px;
      font-weight: 500;
      color: $rfx-dark-march;

      &_highlighted{
        color: $rfx-light-blue;
      }
    }

    &__chart-wrapper {
      flex: 1 1 100%;
      display: flex;
      flex-direction: column;
    }

    &__web-property-select {
      width: 250px;
      right: 610px;
      position: absolute !important;
      top: 15px;
    }

    &__chart {
      flex: 1 1 100%;
      width: 97%;
    }

    &__ticks {
      width: 150px;
    }

    &__checkboxes{
      flex: 1 1 100%;
      padding: 30px 6% 30px 5%;
      display: grid;
      grid-template-columns: repeat(8, 1fr);
      grid-gap: 1vw;
    }

    &__checkbox{
      width: fit-content;
    }
    &__date-picker{
      position: absolute;
      top: 15px;
      right: 390px;
      height: 60px;
      z-index: 9;
    }

    &__competitor{
      background-color: $rfx-red;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      margin-right: 5px;
    }

    &__sibling{
      @extend .area-chart__competitor;
      background-color: $rfx-medium-orange;
    }

    &__client{
      @extend .area-chart__competitor;
      background-color: $rfx-light-green;
    }

    &__color {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
      }
  }

</style>
